/* import __COLOCATED_TEMPLATE__ from './all-orders.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import templateOnlyComponent from '@ember/component/template-only';
import type { ShippingAddress, ShopifyOrder } from '../shopify';

interface Signature {
  Args: {
    shopifyOrders?: ShopifyOrder[] | null;
    onShippingAddressUpdate: (orderId: number, newShippingAddress: ShippingAddress) => void;
    onRefundSuccess?: () => void;
    expandedOrderIds: Set<number>;
    toggleOrderExpanded: (orderId: number) => void;
    shopifyCustomerId?: number;
  };
}

const AllOrders = templateOnlyComponent<Signature>();
export default AllOrders;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::Shopify::AllOrders': typeof AllOrders;
    'inbox2/conversation-details-sidebar/sidebar-sections/shopify/all-orders': typeof AllOrders;
  }
}
